<form [formGroup]="checklistSettingsForm" class="mc-spring-board" (ngSubmit)="onSubmit()">
  <div class="mc-spring-board-form-body">
    <mat-form-field mcColor="secondary" class="mc-form-field">
      <mat-label>Name</mat-label>
      <input type="text" matInput #nameInput formControlName="name" maxLength="40" placeholder="Name">
      <mat-hint align="end">{{ nameInput.value.length }}/40</mat-hint>
      <mat-error>
        <mc-form-control-error-message [form]="checklistSettingsForm" controlName="name" [type]="mode === 'create-checklist' || mode === 'edit-checklist' ? 'mc_checklist_name' : 'mc_checklist_template_name'"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <mat-form-field mcColor="secondary" class="mc-form-field">
      <mat-label>Type</mat-label>
      <mat-select formControlName="type" placeholder="Checklist Type">
        <mat-option [value]="ProjectChecklistType.ProjectFiles">
          {{ ProjectChecklistType.ProjectFiles | mcProjectChecklistTypeDisplayText }}
        </mat-option>
        <mat-option [value]="ProjectChecklistType.GenericList">
          {{ ProjectChecklistType.GenericList | mcProjectChecklistTypeDisplayText }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="showTemplateField" mcColor="secondary" class="mc-form-field">
      <mat-label>Template</mat-label>
      <mat-select formControlName="template" placeholder="Template">
        <mat-option [value]="null"><i>No Template</i></mat-option>
        <mat-option *ngFor="let template of templates$ | async" [value]="template">
          {{ template.Name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="(mode === 'create-checklist' || mode === 'edit-checklist') && checklistSettingsForm?.get('type')?.value === ProjectChecklistType.ProjectFiles" mcColor="secondary" class="mc-form-field mc-form-field-compact">
      <mat-label>Branch</mat-label>
      <mc-autocomplete-input formControlName="branchId" [multiple]="false" [triggerPopupOnFocus]="false" [required]="true">
        <mc-branches-select-list mcAutocompleteList [projectId]="projectId"></mc-branches-select-list>
        <ng-template mcAutocompleteItem let-branchId="item">
          <mc-branch-avatar compact [branchName]="(branchId | mcBranchAsync | async)?.Name" [disabled]="true" size="small" [truncate]="true"></mc-branch-avatar>
        </ng-template>
      </mc-autocomplete-input>
      <mat-error>
        <mc-form-control-error-message [form]="checklistSettingsForm" controlName="branchId" type="mc_branch"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <mat-form-field mcColor="secondary" class="mc-form-field" hintLabel="Max 250 characters">
      <mat-label>Description</mat-label>
      <textarea matInput #descriptionInput formControlName="description" placeholder="Description" maxLength="250"></textarea>
      <mat-hint align="end">{{ descriptionInput.value.length }}/250</mat-hint>
    </mat-form-field>
  </div>

  <div *ngIf="showFormFooter" class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>
    <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
    <div class="mc-form-buttons">
      <button type="button" mat-stroked-button (click)="onCancelClicked()">Cancel</button>
      <button type="submit" mat-raised-button color="primary" [disabled]="!dirty">Save</button>
    </div>
  </div>
</form>